
import { Vue, Component } from "vue-property-decorator";
import { IMeetingInfo, current } from "@/contants/current";
import {
  provinceAndCityData,
  regionData,
  provinceAndCityDataPlus,
  regionDataPlus,
  CodeToText,
  TextToCode,
} from "element-china-area-data";

@Component({ components: {} })
export default class Schedule extends Vue {
  private current: any = {};
  private m: string = "";
  private dateIndex: number = 0; //选中的日期的下标
  private roomIndex: number = 0; //选中的会场的下标
  private dateid: number = 0; //选中的日期id
  private roomid: number = 0; //选中的会场id
  private scheduleDatas: any[] = []; //日程表总数据
  private Datas: any[] = []; //日程表总数据
  private dateDatas: any[] = []; //日期数据
  private addressDatas: any[] = []; // 会场列表数据
  private showAddressDatas: any[] = []; // 会场列表数据
  private selectedMeeting: any = -1; //根据日期和会场选中的会
  private searchWord: string = ""; //搜索的内容
  private searchW: string = ""; //搜索的内容
  private searchVal: any = {};
  private searchDatas: any[] = [];
  private issearch: boolean = false;
  private isLoading: boolean = true;
  private showExList: boolean = false; //是否显示嘉宾弹框
  private isshowprogram: any = '';
  private exDatas: any[] = [];
  private activeName: string = "0";
  private defaultHeadImg: any = require("@/assets/images/defaultHeadImg.png");
  private exPhoto: string = ""; //嘉宾头像
  private cnintroduction: string = ""; //嘉宾介绍
  private excnname: string = ""; //嘉宾姓名
  private cncompany: string = ""; //嘉宾公司
  private is_fixed: boolean = false; //是否吸顶
  private colWidth = 0;
  private fileList = [
    {
      name: "food.jpeg",
      url:
        "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100",
    },
    {
      name: "food2.jpeg",
      url:
        "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100",
    },
  ];

  created() {
    this.current = new current();
    this.m = String(this.$route.query.m);
    let parames = {
      m: this.m,
    };
    this.GetAPIProgram(parames);
	this.InitMeetingInfo()
  }
  mounted() {
    //对整个页面滚轮进行监听，每发生一次滚轮事件，执行一次方法
    window.addEventListener("scroll", this.initHeight);
    let _w = (this.$refs.fixed_W as HTMLElement).clientWidth;
    (this.$refs.fixed_tit as HTMLElement).style.width = _w + "px";

    (document.getElementsByClassName("roomList")[0] as HTMLElement).style.width = _w - 2 + "px";
  }
  /**
   * 日程模块时，左菜单做吸顶效果
   */
  initHeight() {
    //兼容性，获取页面滚动距离
    var scrollTop =
      window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    let _offsetTop = (document.getElementsByClassName("personalCenter_container")[0] as HTMLElement)
      .offsetTop;
    //判断滚动距离是否大于元素到顶端距离
    this.is_fixed = scrollTop > _offsetTop ? true : false;
  }
  async InitMeetingInfo() {
  	let params = {
  		m: this.$route.query.m,
  	};
  	let res = await IMeetingInfo.InitMeetingInfo(params);
  	if (res.Code === 1000) {
  		this.isshowprogram = res.isshowprogram
  	}
  }
  /**
   * 获取日程数据（所有会场id和日期id）
   */
  async GetAPIProgram(parames: any) {
    let res = await this.$http.schedule.GetAPIProgram(parames);

    if (res.Code === 1000) {
      this.dateDatas = res.childens;

      this.getScheduleData(res);

      this.addressDatas = res.RoomDateEntityList;
      // this.showAddressDatas = res.RoomDateEntityList;
    }
  }

  /**
   * 获取所有详细日程数据（DateListEntity）
   */
  getScheduleData(data: any) {
    let { RoomDateEntityList, childens } = data;

    for (let i in childens) {
      let { value, child } = childens[i];
      let dateid = value;
      for (let s in child) {
        let roomid = child[s].value;
        if (dateid != 0 && roomid != 0) {
          let parames = {
            m: this.m,
            dateid,
            roomid,
          };
          this.GetScheduleDatas(parames);
        }
      }
    }
  }
  /**
   * 所有详细日程数据（DateListEntity）
   */
  async GetScheduleDatas(parames: any) {
    this.isLoading = true;

    let _res = await this.$http.schedule.GetAPIProgram(parames);

    if (_res.Code === 1000) {
      if (_res.DateListEntity.length) {
        let _list: any = _res.DateListEntity[0].programListEntity[0].programs.programList;
        // 将时间戳转时间格式
        for (let i in _list) {
          let { starttime, endtime, upproid, expertList, programDate } = _list[i];
          _list[i].starttime = this.convertTime(starttime);
          _list[i].endtime = this.convertTime(endtime);
          let { month, day } = this.current.changeFormDate(programDate.prodate);
          _list[i].programDate.prodate = month + "月" + day + "日";

          if (expertList.length) {
            let _rolenameList = this.filterRolename(expertList);
            _list[i].ssl_identityList = _rolenameList;
          }
        }
        const _data = this.dealData(0, _list);

        _data.unshift({
          roomname: _data[0].programRoom.roomname,
          ssl_roomtitle: _data[0].programRoom.roomtitle,
          id: "ssl_" + _data[0].proid,
          prodate: _data[0].programDate.prodate,
        });
        this.scheduleDatas.push(_data);
        this.Datas.push(_data);
      } else {
        console.log(_res);
      }
    }
    this.isLoading = false;
    console.log("scheduleDatas", this.scheduleDatas);
  }

  /**
   * 处理日程同一身份的嘉宾姓名
   */
  filterRolename(data: any[]) {
    let _rolenameList: any[] = [], //已去重rolename
      _rolename: any[] = []; // 所有rolename
    //去掉重复的身份（rolename）
    for (let i in data) {
      _rolename.push(data[i].exrolemodel.rolename);
      let _indexof = _rolenameList.indexOf(_rolename[i]);
      if (_indexof == -1) {
        _rolenameList.push(data[i].exrolemodel.rolename);
      }
    }
    let _identityList: any[] = []; //去重后的身份和姓名总数据
    _rolenameList.forEach((item: any, index: any, self: any) => {
      let _identity = { rolename: "", exname: [], exid: [] };
      let _exname: any = [], //同一身份的嘉宾姓名
        _exid: any = [];
      for (let n in data) {
        if (item === data[n].exrolemodel.rolename) {
          _exname.push(data[n].exname);
          _identity.rolename = item;
          _identity.exname = _exname;
          _exid.push(data[n].exid);
          _identity.exid = _exid;
        }
      }
      _identityList.push(_identity);
    });
    return _identityList;
  }
  /**
   * 返回09:00式的时间格式
   */
  convertTime(t: any) {
    let { Hour, minute } = this.current.changeFormDate(t);
    return Hour + ":" + minute;
  }

  /**
   *将子日程放入对应的主日程中
   */
  dealData(firstId: any, data: any) {
    let _temp = [];
    for (let i = 0; i < data.length; i++) {
      if (data[i].upproid === firstId) {
        _temp.push(data.splice(i, 1)[0]);
        i--;
      }
    }
    for (let i = 0; i < _temp.length; i++) {
      _temp[i].children = this.dealData(_temp[i].proid, data);
    }
    return _temp;
  }
  /**
   * 选择日期
   */
  handleMeetingDate(i: any, dateid: number) {
    this.scheduleDatas = this.Datas;
    if (i == 0) {
      this.dateIndex = i;
      this.showAddressDatas = [];
      this.issearch = false;
      this.searchDatas = [];
    } else {
      if (this.dateIndex != i) {
        this.dateIndex = i;
        this.dateid = dateid;
        this.roomIndex = 0;
        this.roomid = 0;
        this.selectedMeeting = -1;

        let _addressDatas = [];
        for (let i in this.addressDatas) {
          let item = this.addressDatas[i];
          if (item.dateid == dateid) {
            _addressDatas.push(item);
          }
        }
        this.showAddressDatas = _addressDatas;

        let _datas = [];
        for (let s in this.scheduleDatas) {
          let item = this.scheduleDatas[s];

          if (item[1].dateid == dateid) {
            _datas.push(item);
          }
        }
        this.scheduleDatas = _datas;
      }
    }
  }
  /**
   * 选择会场
   */
  handleMeetingName(index: any, roomid: number) {
    if (index != this.roomIndex) {
      this.roomIndex = index;
      this.roomid = roomid;
      for (let j in this.scheduleDatas) {
        let item = this.scheduleDatas[j];
        for (let i in item) {
          if (item[i].dateid == this.dateid && item[i].roomid == this.roomid) {
            let _dom = "ssl_" + item[i].proid;
            let dom = document.getElementById(_dom) as any;
            if (dom) {
              if (j == "0") {
                var actualTop = dom.offsetTop;
                var current = dom.offsetParent.offsetParent.offsetParent;
                if (current !== null) {
                  actualTop += current.offsetTop;
                }
                document.documentElement.scrollTop =
                  actualTop - document.documentElement.clientHeight / 4;
              } else {
                dom.scrollIntoView({ block: "center" });
              }
              this.selectedMeeting = j;
            }
          }
        }
      }
    }
  }
  /**
   * 合并行或列
   * data:row, column, rowIndex, columnIndex
   */
  objectSpanMethod(data: any) {
    let { row, column, rowIndex, columnIndex } = data;

    //合并第一列
    if (columnIndex === 0 && rowIndex > 0) {
      return [0, 0];
    }
    //合并主题行
    if (rowIndex === 0) {
      if (columnIndex === 0) {
        return [1, 8];
      } else {
        return [0, 0];
      }
    }
  }
  /**
   * 改变列的样式
   */
  cellStyle(data: any) {
    let { row, column, rowIndex, columnIndex } = data;

    if (columnIndex === 1) {
      return { minWidth: "100px" };
    }
    if (columnIndex === 3) {
      return { minWidth: "100px" };
    }

    //主题样式
    if (rowIndex === 0 && columnIndex === 0) {
      // color: "#278dfa",
      return { background: "#eaeaea" };
    }
    //主日程项去掉左侧边框
    if (row.upproid === 0 && columnIndex === 2) {
      return { borderRight: "none" };
    }
  }
  /**
   * @des 搜索
   */
  handleSearch() {
    if (this.searchW != this.searchWord) {
      let _datas = [];
      if (this.searchWord) {
        this.searchW = this.searchWord;
        let parames = {
          m: this.m,
          search: this.searchWord,
        };

        this.searchChData(parames);

        this.issearch = true;
      } else {
        this.issearch = false;
      }
    }
  }
  /**
   * @des 嘉宾个人信息
   */
  async handleExname(exid: number) {
    let parames = {
      m: this.m,
      exid,
    };
    let res = await this.$http.schedule.GetAPIExpertProgram(parames);
    let _list: any[] = [];
    this.showExList = true;
    let { photo, cnintroduction, cncompany, cnname } = res.expert;
    this.exPhoto = photo;
    this.cnintroduction = cnintroduction;
    this.excnname = cnname;
    this.cncompany = cncompany;
    if (cnintroduction) {
      this.cnintroduction = cnintroduction.replace(/\n/g, "<br>");
    }
    res.DateListEntity.map((item: any, index: any) => {
      let _k = [];
      for (let i in item.programListEntity) {
        let _D = item.programListEntity[i];
        let { programList } = _D.programs;
        for (let j in programList) {
          let _S = programList[j];
          programList[j] = {
            // //时间和日期
            createdTime: this.formatDate(_S.programDate.prodate),
            startTime: this.formatTime(_S.starttime),
            endTime: this.formatTime(_S.endtime),
            total: _D.ProgramCount, //总数量
            pohto: res.expert.photo, //头像路径
            topic: _S.topic,
            roomName: _S.programRoom.roomname,
            roomTitle: _S.programRoom.roomtitle,
            roleName: _S.expertList[0].exrolemodel.rolename,
            ProgramCount: item.ProgramCount,
          };
          _k.push(programList[j]);
        }
      }

      _list.push(_k);
    });

    this.exDatas = _list;
    console.log("exDatas", this.exDatas);
  }
  formatTime(val: any) {
    let et = val.split("(");
    let end = et[1].split(")")[0];
    let endtime = Number(end);
    let date = new Date(endtime);
    let h: any = date.getHours();
    h = h < 10 ? "0" + h : h;
    let m: any = date.getMinutes();
    m = m < 10 ? "0" + m : m;
    return h + ":" + m;
  }
  formatDate(val: any) {
    let et = val.split("(");
    let end = et[1].split(")")[0];
    let date = new Date(Number(end));
    let month = date.getMonth() + 1;
    let day = date.getDate();
    return month + "-" + day;
  }
  handleClick(tab: any, event: any) {
    // console.log(tab, event);
  }
  /**
   * 所有详细日程数据（DateListEntity）
   */
  async searchChData(parames: any) {
    this.isLoading = true;
    let _d: any = [],
      _da: any = [];
    let _res = await this.$http.schedule.GetAPIProgram(parames);

    if (_res.Code === 1000) {
      if (_res.DateListEntity.length) {
        _res.DateListEntity.map((items: any) => {
          let item = items.programListEntity;
          for (let i in item) {
            let _i = item[i].programs.programList;
            for (let j in _i) {
              let _j = _i[j];
              let { starttime, endtime, upproid, expertList, programDate } = _j;
              let { month, day } = this.current.changeFormDate(programDate.prodate);
              _j.starttime = this.convertTime(starttime);
              _j.endtime = this.convertTime(endtime);
              _j.programDate.prodate = month + "月" + day + "日";
              _j.ssl_identityList = this.filterRolename(expertList);
              items.programListEntity[i].programs.programList[j] = _j;
            }
            _d = items.programListEntity[i].programs.programList;
            _d = this.dealData(0, _i);
            _d.unshift({
              roomname: _d[0].programRoom.roomname,
              ssl_roomtitle: _d[0].programRoom.roomtitle,
              id: "ssl_" + _d[0].proid,
              prodate: _d[0].programDate.prodate,
            });
            _da.push(_d);
          }
        });
        this.searchDatas = _da;
      } else {
        this.$message.error({ message: "未搜索到", customClass: "errorMessage" });
      }
    }
    this.isLoading = false;
  }
  handleRemove(file: any, fileList: any) {
    console.log(file, fileList);
  }
  handlePreview(file: any) {
    console.log(file);
  }
  handleExceed(files: any, fileList: any) {
    this.$message.warning(
      `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length +
        fileList.length} 个文件`,
    );
  }
  beforeRemove(file: any, fileList: any) {
    return this.$confirm(`确定移除 ${file.name}？`);
  }
}
